import { render, staticRenderFns } from "./PublicView.vue?vue&type=template&id=55a27772"
import script from "./PublicView.vue?vue&type=script&lang=js"
export * from "./PublicView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports